"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let ActionLocTim = class ActionLocTim extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.resetInput = false;
        this.timesResponse = '';
        this.locationResponse = '';
        this.disabledBtn = true;
    }
    mounted() {
        this.resetInput = true;
    }
    r() {
        this.resetInput = true;
    }
    get trialId() {
        const url = window.location.href;
        const match = url.match(/\/trials\/(\d+)/);
        if (match) {
            const trialNumber = match[1];
            return trialNumber; // Resultado: "272"
        }
        else {
            // console.log('No se encontró el id del trials');
        }
    }
    get allTimes() {
        const dataArray = this.summaryConfigData.configuration.locations;
        const uniqueTimesObject = {};
        dataArray.forEach((item) => {
            if (item.treatments && Array.isArray(item.treatments)) {
                item.treatments.forEach((treatment) => {
                    if (treatment.times && Array.isArray(treatment.times)) {
                        treatment.times
                            .filter((time) => time.time !== 0)
                            .forEach((time) => {
                            uniqueTimesObject[time.time] = time;
                        });
                    }
                });
            }
        });
        const uniqueTimesArray = Object.values(uniqueTimesObject);
        return uniqueTimesArray;
    }
    get allLocations() {
        const locations = this.summaryConfigData.configuration.locations;
        return locations;
    }
    modelEmitTimes(val) {
        if (this.mode === 'times') {
            const ids = [];
            for (const time of val) {
                if (time.time !== 0) {
                    ids.push(time.time);
                }
            }
            this.timesResponse = ids;
            if (this.timesResponse.length < 1 ||
                this.locationResponse === '' ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
        else {
            this.timesResponse = val.time;
            if (this.timesResponse === '' ||
                !this.locationResponse ||
                (this.locationResponse && this.locationResponse.length < 1) ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
    }
    modelEmitLocations(val) {
        if (this.mode === 'locations') {
            const ids = [];
            for (const location of val) {
                ids.push(location === null || location === void 0 ? void 0 : location.id);
            }
            this.locationResponse = ids;
            if (this.timesResponse === '' ||
                this.locationResponse.length < 1 ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
        else {
            this.locationResponse = val.id;
            if (this.timesResponse.length < 1 ||
                this.locationResponse === '' ||
                !this.timesResponse ||
                !this.locationResponse) {
                this.disabledBtn = true;
            }
            else {
                this.disabledBtn = false;
            }
        }
    }
    async downloadTrials() {
        let url = '';
        const urlTimes = `/data/results/trials/${this.trialId}/report/location/${this.locationResponse}?times=${this.timesResponse.toString()}`;
        const urlLocations = `/data/results/trials/${this.trialId}/report/time/${this.timesResponse}?locations=${this.locationResponse.toString()}`;
        if (this.mode === 'locations') {
            url = urlLocations;
        }
        else {
            url = urlTimes;
        }
        window.open(url, '_blank');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionLocTim.prototype, "summaryConfigData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionLocTim.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('mode')
], ActionLocTim.prototype, "r", null);
ActionLocTim = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            Button: bmk_ui_framework_1.Button,
        },
    })
], ActionLocTim);
exports.default = ActionLocTim;
